import { useEffect } from "react";

const useOutsideClick = (ref, callback, excludeRefs = []) => {
  const handleClickOutside = (event) => {
    const isExcluded = excludeRefs.some(
      (excludeRef) => excludeRef.current && excludeRef.current.contains(event.target)
    );

    if (ref.current && !ref.current.contains(event.target) && !isExcluded) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [ref, callback, excludeRefs]);
};

export default useOutsideClick;
